
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 30","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.8 6.841a1.5 1.5 0 00.832-.252l1.603-1.068c1.395-.93 3.265.07 3.265 1.747v7.073c0 1.95-1.431 3.566-3.3 3.854v.947c0 .193-.01.383-.03.57a5.4 5.4 0 004.83-5.37V7.267c0-2.875-3.205-4.59-5.597-2.995L16.799 5.34h-6.6a5.4 5.4 0 00-5.37 4.831c.188-.02.378-.03.57-.03h.946a3.901 3.901 0 013.855-3.3h6.6z","fill":"#E6E7E9"}}),_c('path',{attrs:{"d":"M6 23.792a.75.75 0 00-.468.165l-.152.12C3.514 25.57.75 24.243.75 21.853v-6.31a4.65 4.65 0 014.65-4.65h8.4a4.65 4.65 0 014.65 4.65v3.6a4.65 4.65 0 01-4.65 4.65H6z","stroke":"#E6E7E9","stroke-width":"1.5","stroke-linejoin":"round"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6 16.892a.75.75 0 01.75-.75h4.5a.75.75 0 010 1.5h-4.5a.75.75 0 01-.75-.75z","fill":"#E6E7E9"}})])
          )
        }
      }
    